import { retornaLabelDoValorParentesco, validatorParentescoEmDuplicidade, validatorPossui2Dependentes65anos } from './funcoesAuxiliaresZMC';

export class CorrenteEdicaoZMC {
    constructor(
        dependentes,
        parentesco,
        valoresForm,
        valoresAnterioresForm,
        idadeAssociado
    ) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.valoresAnterioresForm = valoresAnterioresForm;
        this.idadeAssociado = idadeAssociado;
    }

    infringeParentescoComAdicionalMais65() {
        const sessentaCincoAnos = 65;

        if (
            validatorPossui2Dependentes65anos(this.dependentes, this.valoresForm, this.idadeAssociado) &&
            this.valoresAnterioresForm.Idade <= sessentaCincoAnos) {
            this.arrayMsgsErro.push('Este plano permite apenas 2 dependentes com idade maior ou igual a 65 anos.');
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidade(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push(`${retornaLabelDoValorParentesco(this.parentesco)}`);
        }

        return this;
    }
}
